import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../api';
import {
  Heading,
  Text,
  VStack,
  Button,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from '@chakra-ui/react';
import { Link, Navigate } from 'react-router-dom';
import ProductList from './menu-admin/products/ProductList';
import ComboList from './menu-admin/combos/ComboList';
import EventDatesEditor from './menu-admin/settings/EventDatesEditor';
import MenuPreview from './menu-admin/preview/MenuPreview';

export default function MenuAdminPage() {
  const [user] = useAuthState(auth);

  if (!user || user?.displayName !== 'admin') {
    return <Navigate to='/dashboard' replace={true} />;
  }

  return (
    <VStack w='100%'>
      <Heading mt={5} mb={0} color={'white'}>
        Gestione menù
      </Heading>
      <Text mb={3}>{process.env.REACT_APP_PROJECT_ID}</Text>
      <Button mb={3} as={Link} to='/dashboard'>
        Dashboard
      </Button>
      <Tabs variant='enclosed' w='100%' colorScheme='teal' isFitted>
        <TabList>
          <Tab>Prodotti</Tab>
          {/* <Tab>Combo</Tab> */}
          <Tab>Date evento</Tab>
          <Tab>Anteprima</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <ProductList />
          </TabPanel>
          {/* <TabPanel>
            <ComboList />
          </TabPanel> */}
          <TabPanel>
            <EventDatesEditor />
          </TabPanel>
          <TabPanel>
            <MenuPreview />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </VStack>
  );
}

